import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useAsync } from 'react-use';
import moment from 'moment';
import { bindActionCreators } from 'redux';

import { ibeStylists } from 'actions/stylist/beSalonStylists.action';
import IMG_CALENDAR from 'assets/images/icons/calendar-days-black.svg';
import InlineSpinner from 'components/generic/InlineSpinner.component';
import CN from 'components/menu/SidebarMenu.module.scss';
import S from 'constants/string.const';
import useTip from 'hooks/useTip.hook';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import alen from 'utils/arrays/alen.util';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import linkToCalendar from 'utils/links/linkToCalendar';
import logger from 'utils/logger.util';

const L = logger('NavLinkToCalendar'); // eslint-disable-line no-unused-vars

const isActive = (item) => item?.status === 'active';

const NavLinkToCalendar = ({ onClick, ibeStylists, stylists: stylistsFromProps }) => {
  const salonId = useCurrentSalonId();

  const { val: isDone, yay: markDone } = useTip(false);
  const hasFromProps = fromAnyToBool(stylistsFromProps?.[0]);

  const {
    loading: isLoadingStylists,
    error,
    value: stylistsFromFetch,
  } = useAsync(async () => {
    if (isDone || hasFromProps) return;

    const result = await ibeStylists(salonId);
    markDone();

    return asArray(result.json);
  }, [isDone, hasFromProps, ibeStylists, salonId, markDone]);

  if (error) {
    L.warn('()', isDone, isLoadingStylists, error, stylistsFromFetch, stylistsFromProps);
  } else {
    const lengthFromFetch = alen(stylistsFromFetch);
    const lengthFromProps = alen(stylistsFromProps);
    L.debug('()', isDone, isLoadingStylists, error, lengthFromFetch, lengthFromProps);
  }

  const week = moment().format('W[W]YYYY');
  const stylists = asArray(stylistsFromFetch ?? stylistsFromProps).filter(isActive);
  const to = linkToCalendar({ stylists, salonId, week }) || S.hash;

  return (
    <NavLink to={to} activeClassName="active" className={CN.item} onClick={onClick}>
      <img src={IMG_CALENDAR} alt="Menu icon calendar" className={CN.menuIcon} />
      Calendar
      {isLoadingStylists && (
        <span>
          {S.space}
          <InlineSpinner />
        </span>
      )}
    </NavLink>
  );
};

const NavLinkToCalendarHoc = connect(
  (state) => ({ stylists: selectCurrentSalonStylists(state) }),
  (dispatch) => bindActionCreators({ ibeStylists }, dispatch),
)(NavLinkToCalendar);

export default NavLinkToCalendarHoc;
